import { render, staticRenderFns } from "./semiconductor.vue?vue&type=template&id=a00a7ef2&scoped=true&"
import script from "./semiconductor.vue?vue&type=script&lang=js&"
export * from "./semiconductor.vue?vue&type=script&lang=js&"
import style0 from "./semiconductor.vue?vue&type=style&index=0&id=a00a7ef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00a7ef2",
  null
  
)

export default component.exports